<template>
  <transition name="partner-list">
    <section v-if="displayKeys.length > 0 && tilesToDisplay">
      <h3 v-if="showHeader" class="text-h4">Highlighted care through our partners</h3>
      <div class="flex gap-16 overflow-x-scroll lg:overflow-x-visible hide-scrollbar pb-12 pt-16 max-w-screen">
        <BHPartnerCard
          v-for="key in displayKeys"
          :key="key"
          :partner-key="key"
          class="min-w-[212px]"
          variant="small"
          :header-image-url="ALL_PARENT_PARTNER_CARDS[key].headerImage"
          :title="ALL_PARENT_PARTNER_CARDS[key].title"
          :details-url="ALL_PARENT_PARTNER_CARDS[key].detailsUrl"
          :first-line-text="`by ${ALL_PARENT_PARTNER_CARDS[key].companyName}`"
          :second-line-text="secondLineText(ALL_PARENT_PARTNER_CARDS[key].ages)"
          :observer="observer"
          open-in-new-window
          tall-header
          @cta-clicked="ctaClicked(key)"
        />
      </div>
      <p class="text-caption text-grey-text-subdued mb-12">Sittercity may receive a small commission for your purchase</p>
      <Button class="mb-12 p-0" variant="text" href="/explore/partners" value="More partners" />
    </section>
  </transition>
</template>

<script lang="ts">
import Button from '@/components/button/Button.vue';
import BHPartnerCard from '@/components/bh_partners/BHPartnerCard.vue';
import partners from '@/lib/partners';
import partnersData from '@/lib/partners.data';

export default {
  name: 'BHPartnersList',
  components: { Button, BHPartnerCard },
  props: {
    showHeader: {
      type: Boolean,
      default: true,
      required: false,
    },
    zipCode: {
      type: String,
      required: false,
      default: '',
    },
  },
  data(): any {
    return {
      tilesToDisplay: true,
      ALL_PARENT_PARTNER_CARDS: partnersData.ALL_PARENT_PARTNER_CARDS(),
      displayKeys: [],
      observer: null as any,
    };
  },
  watch: {
    zipCode(newZip) {
      this.displayKeys = partners.getPartners(3, newZip);
    },
  },
  mounted() {
    this.displayKeys = partners.getPartners(3, this.zipCode);
  },
  created() {
    this.observer = new IntersectionObserver(this.onElementObserved, {
      root: this.$el,
      threshold: 0.5,
    });
  },
  beforeUnmount() {
    this.observer.disconnect();
  },
  methods: {
    onElementObserved(entries) {
      entries.forEach(({ target, isIntersecting }) => {
        if (!isIntersecting) {
          return;
        }

        this.observer.unobserve(target);
        const key = target.getAttribute('id');
        partners.sendPartnerSegmentEvent('Partner Impression', key);
      });
    },
    secondLineText(ageRange) {
      if (ageRange) {
        if (ageRange === 'All ages') return ageRange;
        return `Ages ${ageRange}`;
      }
      return null;
    },
    ctaClicked(key) {
      partners.partnerClicked(key);
    },
  },
};
</script>
<style scoped>
.partner-tiles-item {
  transition: all 0.3s;
  display: inline-block;
  margin-right: 10px;
}

.partner-tiles-enter-active {
  transition-delay: 0.3s;
}

.partner-tiles-enter,
.partner-tiles-leave-to {
  opacity: 0;
}

.partner-tiles-leave-active {
  position: absolute;
}

.partner-list-leave-active {
  /*
  Setting max-height to 350 as a reasonable guess to the actual
  height of the BHPartnersList component.
  - .partner-card is 275px
  - Header height is roughly 24px
  - Adding some 'padding' on top of that
  This should provide a 'wipe-up' looking transition-out effect.
  */
  max-height: 350px;
  opacity: 1;
  transition: all 0.3s;
}

.partner-list-leave-to {
  max-height: 0;
  opacity: 0;
  margin-bottom: 0;
}
</style>
